import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="district-select"
export default class extends Controller {
  static targets = ["select", "link"];

  connect() {
    this.update();
  }

  update() {
    const value = this.selectTarget.value;
    const url = new URL(this.linkTarget.href, window.location.origin);
    if (value) url.searchParams.set("district_id", value);
    else url.searchParams.delete("district_id");
    this.linkTarget.href = url.toString();
  }
}
